<!-- alert-list.component.html -->
<div
  *ngFor="let alert of alerts"
  class="alert"
  [ngClass]="'alert-' + alert.type"
  [class.fade-out]="alert.closing"
  (animationend)="onAnimationEnd(alert, $event)"
>
  <div class="icon__wrapper">
    <span class="material-icons">
      {{ alert.type === 'success' ? 'check_circle' :
         alert.type === 'warning' ? 'warning' :
         alert.type === 'error'   ? 'error' :
         alert.type === 'dark'    ? 'info' : 'notifications' }}
    </span>
  </div>

  <p [innerHTML]="alert.message"></p>

  <button mat-icon-button class="close-btn" type="button" (click)="dismiss(alert)">
    <span class="material-icons">cancel</span>
  </button>
</div>
